import React from 'react'
import { Main } from 'layouts'
import { AutopilotFeatures } from 'components/Phantom/_sections/AutopilotFeatures'
import { ImageCTA } from 'components/Phantom/_sections/ImageCTA'
import { MakeYourSideYourOwnConnected } from 'components/Phantom/_sections/MakeYourSideYourOwn'
import { SleepAndHealthReportOverview } from 'components/Phantom/_sections/SleepAndHealthReportOverview'
import { ExtraordinaryPeopleStatic } from 'components/Phantom/_sections/ExtraordinaryPeopleStatic'
import { ScrollSequenceStatic } from 'components/Phantom/_sections/ScrollSequenceStatic'
import { Pod4HeroHIW } from 'components/Phantom/_sections/Pod4Hero'
import { ThisIsPod4Ultra } from 'components/Phantom/_sections/ThisIsPod4Ultra'
import { CoolingPowerConnected } from 'components/Pod4CoolingPower'
import { EnergyBenefitsConnected } from 'components/Phantom/_sections/EnergyBenefits'
import { NewBaseConnected } from 'components/Pod4NewBase'
import { Pod4ElevateSleep } from 'components/Pod4ElevateSleep'
import { Pod4SeamlessSnoring } from 'components/Pod4SeamlessSnoring'
import { InvisibleComfort } from 'components/Phantom/_sections/Pod4Comfort'
import { BestWayToWakeUp } from 'components/Phantom/_sections/BestWayToWakeUp'
import { NoPhoneConnected } from 'components/Pod4NoPhone'
import { observer } from 'mobx-react'
import { useRootStore } from 'components/_hooks/useRootStore'
import { ClientOnly } from 'components/ClientOnly'
import Pod4ShopComparison from 'components/Pod4ShopComparison/Pod4ShopComparison'
import { Sticky } from 'components/WebEv/CoverLP2023/Sticky'
import { PriceManager } from 'prices'

export const HowItWorks = observer(() => {
	const { settingsStore, priceStore } = useRootStore()

	return (
		<Main>
			<div className={'disable-transitions'}>
				<Sticky
					stickyName={'Pod 4'}
					price={priceStore.pod4PriceFormatted}
					strikePrice={priceStore.pod4ComparePriceFormatted}
					monthlyPrice={priceStore.pod4MonthlyPriceFormatted}
					months={priceStore.coverMaxMonthsAtZeroInterest}
					showFinancing={PriceManager.currencyHasAffirm(priceStore.currency)}
					discount={priceStore.podDiscountFormatted}
					discountLine={settingsStore.settings.stickyCardTag}
					discountLineMobile={settingsStore.settings.stickyCardTagMobile}
					setHeight={settingsStore.setCoverStickyHeight}
				/>
				<Pod4HeroHIW />
				<ThisIsPod4Ultra />
				<ClientOnly>
					<CoolingPowerConnected />
					<EnergyBenefitsConnected />
					<MakeYourSideYourOwnConnected />
					<NewBaseConnected />
					<Pod4ElevateSleep />
					<Pod4SeamlessSnoring />
					<InvisibleComfort />
					<BestWayToWakeUp />
					<NoPhoneConnected />
					<AutopilotFeatures />
					<ImageCTA />
					{/*<BetterThanAWearable />*/}
					<SleepAndHealthReportOverview />
					{/*<AppOverviewTour />*/}
					{/*<LegKitBriefer />*/}
					<ExtraordinaryPeopleStatic />
					<Pod4ShopComparison />
					<ScrollSequenceStatic />
				</ClientOnly>
			</div>
		</Main>
	)
})
